import React from 'react';
import FeaturedPodcastCard, { FeaturedPodcastCardEpisode } from './FeaturedPodcastCard';
import { Carousel } from '@benzinga/ui';

export interface FeaturedPodcastCardsBlockProps {
  episodes: FeaturedPodcastCardEpisode[];
  embeddedTitle?: React.ReactElement;
}

export const FeaturedPodcastCardsBlock: React.FC<FeaturedPodcastCardsBlockProps> = ({ embeddedTitle, episodes }) => {
  if (!Array.isArray(episodes)) return null;
  if (episodes.length === 1) {
    return <FeaturedPodcastCard episode={episodes[0]} />;
  }
  return (
    <div>
      <React.Suspense fallback={<div />}>
        <Carousel
          arrowsPosition="center"
          className="featured-podcasts-carousel"
          component={(episode: FeaturedPodcastCardEpisode) => (
            <div className="featured-podcast-card-wrapper flex flex-col z-[2] mx-auto h-full" key={episode.id}>
              <FeaturedPodcastCard episode={episode} />
            </div>
          )}
          embeddedTitle={embeddedTitle}
          items={episodes}
          options={{ arrows: true, focus: episodes?.length >= 3 ? 'center' : 0, snap: true, type: 'loop' }}
        />
      </React.Suspense>
    </div>
  );
};

export default FeaturedPodcastCardsBlock;
